// extracted by mini-css-extract-plugin
module.exports = {"section":"DimensionContentSection_section__RKJC6","title":"DimensionContentSection_title__5UnWC"};